// extracted by mini-css-extract-plugin
export default {"sectionItem":"SectionsListItem_sectionItem__eGKbl"};